import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import { useDatabaseDeadlock } from "../../Hooks/Features/Inspectra/useDatabaseDeadlock";
import { Dialog } from "primereact/dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-multi-date-picker";
import { SkeletonContainer } from "../Loader/Loader.jsx";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import { dateConvert, timePickerMuiCss } from "../../utils/Helper.js";
import { Calendar } from "primereact/calendar";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const DatabaseDeadlock = ({ projectChanged }) => {

    const { options, showPopup, setShowPopup, popupData, showMore, setShowMore, hoveredRange, loader, showFilter, setShowFilter, filterOpts, filterValues, setFilterValues, filterCount, expand, setExpand, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters } = useDatabaseDeadlock({ projectChanged });

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Database Deadlocks</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-date-string">{dateConvert(filterValues?.date?.from_date, "date-time-months")} - {dateConvert(filterValues?.date?.to_date, "date-time-months")}</div>
            <div className="inspectra-widget-content">
                {loader ? <SkeletonContainer /> :
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                }
            </div>

            <div className="position-absolute bottom-0 end-0 me-1 fs-6 c-pointer" onClick={() => setExpand(true)}>
                <FontAwesomeIcon icon="fa-solid fa-expand" />
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Database Deadlocks Filters">
                <div>
                    <div className="d-flex gap-2 inspectra-calendar">
                        <div className="w50">
                            <div>Date: </div>
                            <div>
                                <DatePicker portal zIndex={99999} value={hoveredRange} onChange={handleDateRange} range rangeHover placeholder="Select Date Range" style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="w45 d-flex gap-2 justify-content-between">
                            <div className="w50">
                                <div>From Time: </div>
                                <TimePicker value={time?.from || null} onChange={(e) => setTime((prev) => ({ ...prev, from: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                            <div className="w50">
                                <div>To Time: </div>
                                <TimePicker value={time?.to || null} onChange={(e) => setTime((prev) => ({ ...prev, to: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Databases:</div>
                            <MultiSelect options={filterOpts?.dbname} placeholder="Databases" value={filterValues?.dbname} onChange={(e) => setFilterValues((prev) => ({ ...prev, dbname: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'dbname', filterValues?.dbname, () => setFilterValues((prev) => ({ ...prev, dbname: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => handleDefaultFilters()}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => { setShowPopup(false); setShowMore({ sql: { visible: false, index: null }, raw_data: { visible: false, index: null } }) }} draggable={false} className="modal-large inspectra-grey-dialog" header="Database Deadlocks Details">
                <div>
                    <div className="deadlock-modal-content">
                        {popupData?.map((dl, index) => (
                            <div key={index} className="deadlock-entry inspectra-popup-card">
                                <div className="deadlock-header">{dl.project_name} - {new Date(dl.DeadlockTime).toLocaleString()}</div>

                                <p className="d-flex justify-content-between w25">
                                    <strong>Database Name:</strong>
                                    <span>{dl?.dbname}</span>
                                </p>

                                <p className="d-flex justify-content-between w20">
                                    <strong>SQL Snippet:</strong>
                                    <span onClick={() => setShowMore((prev) => ({ ...prev, sql: { visible: showMore?.sql?.index !== index ? true : !showMore?.sql?.visible, index: index !== null ? index : null } }))} style={{ cursor: "pointer", color: "#b7b7b7" }}>
                                        <FontAwesomeIcon icon="fa-solid fa-caret-down" />
                                    </span>
                                </p>
                                {showMore?.sql?.visible && showMore?.sql?.index === index && <pre>{dl.DeadlockXML}</pre>}

                                <p className="d-flex justify-content-between w20">
                                    <strong>Raw Event Data:</strong>
                                    <span onClick={() => setShowMore((prev) => ({ ...prev, raw_data: { visible: showMore?.raw_data?.index !== index ? true : !showMore?.raw_data?.visible, index: index !== null ? index : null } }))} style={{ cursor: "pointer", color: "#b7b7b7" }}>
                                        <FontAwesomeIcon icon="fa-solid fa-caret-down" />
                                    </span>
                                </p>
                                {showMore?.raw_data?.visible && showMore?.raw_data?.index === index && <pre className="event-data">{dl.event_data}</pre>}
                            </div>
                        ))}
                    </div>
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Database Deadlocks Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                </div>
            </Dialog>
        </div>
    )
}

export default DatabaseDeadlock;